var map = {
	"./active-star.svg": 698,
	"./advantages-icon.svg": 691,
	"./arrow-down-stroke-icon-red.svg": 699,
	"./arrow-down-stroke-icon-white.svg": 700,
	"./arrow-down-stroke-icon.svg": 701,
	"./background_black-icon.svg": 702,
	"./background_blue-icon.svg": 703,
	"./background_white-icon.svg": 704,
	"./background_yellow-icon.svg": 705,
	"./blockquote-icon.svg": 706,
	"./box-icon.svg": 707,
	"./card-icon.svg": 708,
	"./cart-icon--black.svg": 709,
	"./cart-icon-stroke--white.svg": 710,
	"./cart-icon-stroke.svg": 711,
	"./cart-icon.svg": 712,
	"./category-list-icon.svg": 713,
	"./checkmark-icon--green.svg": 692,
	"./checkmark-icon--white.svg": 714,
	"./checkmark-icon-strong-black.svg": 715,
	"./checkmark-icon-strong-white.svg": 716,
	"./checkmark-icon.svg": 717,
	"./chevron-down-white.svg": 718,
	"./chevron-right-black.svg": 719,
	"./chevron-right-white.svg": 720,
	"./close-icon-black.svg": 721,
	"./close-icon-fill.svg": 722,
	"./close-icon-orange.svg": 723,
	"./close-icon.svg": 724,
	"./comparison-icon-blue.svg": 725,
	"./comparison-icon.svg": 726,
	"./cookie-icon.svg": 727,
	"./devices-icon.svg": 728,
	"./dislike-icon.svg": 729,
	"./download-icon.svg": 730,
	"./editor/material/canvas-frame-lg.svg": 731,
	"./editor/material/canvas-frame-md.svg": 732,
	"./editor/material/canvas.svg": 733,
	"./editor/material/rigid-material.svg": 734,
	"./editor/orientation/horizontal-orientatio-icon.svg": 735,
	"./editor/orientation/vertical-orientation-icon.svg": 736,
	"./error-icon.svg": 270,
	"./facebook-icon-white.svg": 737,
	"./facebook-icon.svg": 738,
	"./flag-icon--en.svg": 739,
	"./flag-icon--hu.svg": 740,
	"./gallery-icon.svg": 688,
	"./gls-icon.jpg": 741,
	"./gls-pp-icon.jpg": 742,
	"./half-active-star.svg": 743,
	"./hearth-icon-black.svg": 744,
	"./hearth-icon.svg": 745,
	"./hearts-icon.svg": 746,
	"./image-icon.svg": 689,
	"./inactive-star.svg": 747,
	"./info-fill-icon.svg": 693,
	"./insta-icon-white.svg": 748,
	"./insta-icon.svg": 749,
	"./like-icon--red.svg": 750,
	"./like-icon.svg": 751,
	"./login-icon-white.svg": 752,
	"./login-icon.svg": 753,
	"./magnifier-icon-white.svg": 754,
	"./magnifier-icon.svg": 755,
	"./mail-icon.svg": 756,
	"./marker--hearth-white-stroke.svg": 757,
	"./marker--hearth-white.svg": 758,
	"./marker--hearth.svg": 759,
	"./marker--invisible-stroke.svg": 760,
	"./marker--invisible.svg": 761,
	"./marker--party-face.svg": 762,
	"./marker--red.svg": 763,
	"./marker--smile-hearth-eyes.svg": 764,
	"./marker--smile.svg": 765,
	"./marker--thumbs-up.svg": 766,
	"./marker--yellow.svg": 767,
	"./marker.svg": 768,
	"./orders-icon.svg": 769,
	"./paypal-icon.jpg": 770,
	"./phone-icon.svg": 771,
	"./plus-icon-blue.svg": 772,
	"./plus-icon-red.svg": 773,
	"./registration-icon-white.svg": 774,
	"./registration-icon.svg": 775,
	"./sad-icon.svg": 776,
	"./shape_arch-icon.svg": 777,
	"./shape_circle-icon.svg": 778,
	"./shape_diamond-icon.svg": 779,
	"./shape_heart-icon.svg": 780,
	"./shape_hexagon-icon.svg": 781,
	"./shape_octagon-icon.svg": 782,
	"./shape_oval-icon.svg": 783,
	"./shape_rectangle-icon.svg": 784,
	"./shape_rosette-icon.svg": 785,
	"./shape_rounded-icon.svg": 786,
	"./shape_shield-icon.svg": 787,
	"./shape_star-icon.svg": 788,
	"./sheet-icon-white.svg": 789,
	"./sheet-icon.svg": 790,
	"./store-icon-white.svg": 791,
	"./store-icon.svg": 792,
	"./successful-icon.svg": 694,
	"./transport-icon.svg": 793,
	"./tweet-icon-white.svg": 794,
	"./tweet-icon.svg": 795,
	"./user-icon-white.svg": 796,
	"./user-icon.svg": 797,
	"./wallet-icon.svg": 798,
	"./zoom-icon.svg": 799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1240;